import { sample } from 'effector'

import { logger } from '@portal/logger'

import { portalProfileAPI } from '@/entities/profile/portal'
import { getCSRFToken } from '@/shared/api/csrf'
import { env } from '@/shared/config'
import { appStarted } from '@/shared/lib/app'

// initialize analytics
import '@/app/analytics/portal'

// initialize language
import '@/app/language/portal'

// initialize terms
import '@/app/terms/portal'

// initialize sentry
import '@/app/sentry/portal'

// initialize chat
import '@/app/chat/portal'

sample({
    clock: appStarted,
    filter: () => Boolean(getCSRFToken()),
    target: portalProfileAPI.me,
})

// set global log level
logger.level = env.LOG_LEVEL
